import React, { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import ReactPlayer from 'react-player';

import styles from "../styles/footer.module.css";


const Footer = () => {

    return (
        <>
        <div className={styles.footer_spacer}></div>
        <footer className={styles.footer}>
            <div className={styles.footer_content}>
                <p className={styles.footer_text}>© 2025 TocaHealth. All rights reserved.</p>
                {/* <div className={styles.footer_links}>
                    <a href="#" className={styles.footer_link}>Contact Us</a>
                    <a href="#" className={styles.footer_link}>Privacy Policy</a>
                    <a href="#" className={styles.footer_link}>Terms of Service</a>
                </div> */}
            </div>
        </footer>
        </>
    );
};

export default Footer;
